export const POST_RESULT_RELEASE_SEARCH_PARAM = '/results/search';
export const GET_CANDIDATE_RELEASE_BY_INDEX_NO='/results';
export const BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE = '/results';

